import React, { useEffect, useState } from "react";
import AppContent from "../components/AppContent/AppContent";
import Navbar from "components/Navbar/Navbar";
import { useIdleTimer } from "react-idle-timer";
import { postLogout } from "service/api";
import { useAuthStore } from "store/auth";
import UseToast from "utils/AfToast";
import { useNavigate } from "react-router-dom";

export function DefaultLayout() {
  const [state, setState] = useState<string>("Active");
  const [remaining, setRemaining] = useState<number>(0);
  const [count, setCount] = useState<number>(0);

  const { setToken, setUser, token, removeAll } = useAuthStore();
  const navigator = useNavigate();

  const onIdle = () => {
    setState("Idle - Do Logout");
    postLogout({ data: {}, headers: { Authorization: "Bearer " + token } })
      .then((res) => {
        UseToast("Logout Due to Inactivity", "warning");
        localStorage.removeItem("af_token");
        removeAll();
        navigator("/login");
      })
      .catch((err) => {
        console.error(err);
        UseToast("Logout Failed! Try Again", "error");
      });
  };

  const onActive = () => {
    setState("Active");
  };

  const onMessage = () => {
    setCount(count + 1);
  };
  const { getRemainingTime, getTabId, isLeader, isLastActiveTab, message } = useIdleTimer({
    onIdle,
    onActive,
    onMessage,
    timeout: 1000 * 60 * 25,
    //timeout: 1000 * 60 * 25,
    crossTab: true,
    leaderElection: true,
    syncTimers: 200,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <>
      <section>
        <div className="relative min-h-screen flex flex-col">
          <Navbar />

          <div className="flex-1 flex flex-col">
            <AppContent />
            {/* <div className="bg-background_grey h-screen"> */}
            <div className="bg-background_grey height-class"></div>
          </div>
        </div>
      </section>
    </>
  );
}
